import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { REQUEST_STEPS, TRIN_USER } from '../enum-request-steps';
import {
  CAR_TYPE,
  MarketPlaceQuoteRequestService,
} from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { Router } from '@angular/router';
import { first, lastValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  LoginService,
  User,
} from 'src/app/services/login-service/login.service';
import { ConfigService } from 'src/app/services/config-service/config.service';
import { filterSelectionState } from 'src/app/routes/search-cars-component/search-cars.helper.consts';
import { HoldFileService } from '../../../../services/hold-file-service/hold-file.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../services/mixpanel-service/mixpanel.service';
import { SubmitQuoteDialogComponent } from '../../../../components/submit-quote-dialog/submit-quote-dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

enum SUBMIT_STATUS {
  ERROR_STATUS = 0,
  SUCCESS_STATUS = 1,
}

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
})
export class ReviewComponent implements OnInit {
  private _configService_: ConfigService;
  private _holdFileService_: HoldFileService;

  final: any;
  loading = false;
  selectedCarType: any;
  mechanicalOptions: any;
  isPhonePlaceholderHidden = false;
  enum_car_type = CAR_TYPE;
  enumSubmitStatus = SUBMIT_STATUS;
  enumRequestSteps: any = REQUEST_STEPS;
  submitStatus = -1;
  selectedCars: any = [];
  selectedStcc: any;
  cardAttrList: any;
  clientData: User = {} as User;
  isTrinUserValue = false;

  CountryCodeOptions = [
    { label: '+1', value: '+1' },
    { label: '+52', value: '+52' },
  ];

  config;
  isTrinUser$: any;

  ref: DynamicDialogRef | undefined;

  frmContact = new FormGroup({
    country_code: new FormControl('+1'),
    phone_no: new FormControl('', { updateOn: 'blur' }),
  });

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private router: Router,
    private httpClient: HttpClient,
    private loginService: LoginService,
    private draftQuoteService: draftQuoteRequest,
    public dialogService: DialogService,
    private mixpanelService: MixpanelService,
    configService: ConfigService,
    holdFileService: HoldFileService
  ) {
    this._configService_ = configService;
    this._holdFileService_ = holdFileService;

    const config = localStorage.getItem('config-service');
    if (config) {
      this.config = JSON.parse(config);
    }

    this.quoteRequestService.quoteRequest$.subscribe((response) => {
      this.final = response;

      this.selectedCarType = this.quoteRequestService.getSelectedCarType();

      this.mechanicalOptions =
        this.final['mechanical-options'][this.selectedCarType];

      const phone = this.quoteRequestService.getAlternativePhone();
      if (phone.length > 0) {
        this.frmContact.patchValue({
          country_code: phone[0],
          phone_no: phone[1],
        });
        this.isPhonePlaceholderHidden = true;
      }
    });

    this.loginService.user$.subscribe((res) => {
      this.clientData = res;
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    // browser back button event
    if (this.submitStatus === this.enumSubmitStatus.SUCCESS_STATUS)
      window.location.reload();
  }

  ngOnInit(): void {
    const storedEmail = localStorage.getItem('userEmail');
    if (storedEmail) {
      this.loginService.isTrinUser(storedEmail).subscribe({
        next: (isTrinUser) => {
          this.isTrinUserValue = isTrinUser;
        },
        error: () => {
          this.isTrinUserValue = false;
        },
      });
    }

    const { cardAttrList, selectedCars } =
      this.quoteRequestService.getSelectedCarList();
    this.cardAttrList = cardAttrList;
    this.selectedCars = selectedCars;
    const stcc = this.quoteRequestService.getDefaultStcc()?.description_stcc;
    this.selectedStcc =
      stcc === 'Other' ? this.quoteRequestService.getProductName() : stcc;

    const comments = this.final?.['lease-details']?.comments;
    if (comments) {
      this.final['lease-details'].comments = comments.replace(
        /(<([^>]+)>)/gi,
        ''
      );
    }
  }

  validatePhone() {
    return !(
      this.frmContact.value.phone_no === '' &&
      this.frmContact.value.phone_no !== ''
    );
  }

  back() {
    window.scrollTo(0, 0);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
  }

  goToStep(step: REQUEST_STEPS) {
    this.quoteRequestService.setNextStep(step);
    window.scrollTo(0, 0);
  }

  show(userEmail: string) {
    this.ref = this.dialogService.open(SubmitQuoteDialogComponent, {
      baseZIndex: 10000,
      closeOnEscape: true,
      contentStyle: { padding: '0', width: '100%' },
      style: { width: '99%', maxWidth: '100%', padding: '0', margin: '0' },
      closable: true,
    });

    this.ref.onClose.subscribe((data) => {
      if (data) {
        this.continueSubmit(userEmail, data, TRIN_USER);
      }
    });
  }

  async submit() {
    const userEmail = localStorage.getItem('userEmail') || '';
    try {
      // Use the value stored from the `ngOnInit()` subscription
      if (this.isTrinUserValue) {
        this.show(userEmail);
      } else {
        this.continueSubmit(userEmail, null);
      }
    } catch (err) {
      this.continueSubmit(userEmail, null);
    }
  }

  continueSubmit(userEmail: string, data: any, from?: string) {
    this.mixpanelService.trackEndTime(
      'quote submit button click time',
      userEmail
    );
    this.loading = true;
    let phone = '';
    if (this.frmContact.value.phone_no !== '') {
      const first3 = this.frmContact.value.phone_no.toString().slice(0, 3);
      const last7 = this.frmContact.value.phone_no.toString().slice(3, 10);
      phone = this.frmContact.value.country_code + ' (' + first3 + ')' + last7;
    }

    let selectedMode = 'sandbox';
    let customerId = null;
    let customerContactId = null;
    if (data) {
      selectedMode = data.mode;
      if (data.mode === 'business') {
        customerId = data.customer.customer_id;
        customerContactId = data.contact.user_id;
      }
    }

    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Selected Mode',
      eventDisplayName: selectedMode,
      kpi: 'User Engagement',
      trigger: 'On Button quote submit',
      eventDefinition: 'User submits the quote submit button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button quote submit',
      additionalProperties: {
        parentEvent: 'Begin Quote',
        subParentEvent: 'Review Quote Details Mode',
        mode: selectedMode,
      },
    });

    const obj = {
      'user-profile': {
        date: new Date(),
        userid: this.clientData['contact-info'].userid,
        customerid: customerId,
        customercontactid: customerContactId,
      },
      'lease-details': this.final['lease-details'],
      'mechanical-options': this.final['mechanical-options'],
      'selected-stcc': this.selectedStcc,
      'user-filter': this.quoteRequestService.getActiveFilter(),
      'selected-cars': this.selectedCars,
      'selected-car-type': this.selectedCarType,
      'alternative-phone': phone,
    };

    this.mixpanelService.track({
      id: userEmail,
      eventName: 'End Quote',
      eventDisplayName: obj,
      kpi: 'User Engagement',
      trigger: 'On Button quote submit',
      eventDefinition: 'User submits the quote submit button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button quote submit ',
      additionalProperties: {
        parentEvent: 'Begin Quote',
        subParentEvent: 'Review Quote Details',
      },
    });

    this.quoteRequestService.setSelectedCarList([], []);

    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();

    const handleError = (error: any) => {
      this.loading = false;
      this.router.navigate(['/search-inventory/error']);
    };

    const handleResponse = (response: any) => {
      history.pushState(
        null,
        '',
        window.location.origin + '/search-inventory/'
      );
      window.scrollTo(0, 0);
      this.quoteRequestService.setNextStep(REQUEST_STEPS.SUBMIT);
      this.submitStatus = this.enumSubmitStatus.SUCCESS_STATUS;
      sessionStorage.removeItem(filterSelectionState);
      this.quoteRequestService.setSelectedCarList([], []);

      this.loading = false;
    };

    const promiseHandler = (submission$: Observable<any>) => {
      submission$
        .pipe(first())
        .subscribe({ next: handleResponse, error: handleError });
    };

    if (
      (selectedMode !== 'sandbox' && from === TRIN_USER) ||
      (selectedMode === 'sandbox' && from !== TRIN_USER)
    ) {
      const submission: Promise<Observable<any>> = this.handleSubmission(
        obj,
        token
      );
      submission.then(promiseHandler);
    } else {
      this.draftQuoteService.deleteDraftQuation();
      this.submitStatus = this.enumSubmitStatus.SUCCESS_STATUS;
      this.loading = false;
    }
  }

  async handleSubmission(customerQuote: any, token: any) {
    const fetchPresignedURLAsync = (fileName: string): Observable<any> => {
      const headers: any = { 'Content-Type': 'application/json' };
      const options: any = { headers: headers };
      const body: any = { name: fileName };

      return this.httpClient.post(
        this._configService_.presignedURL,
        body,
        options
      );
    };

    const fetchPresignedURLSync = (fileName: string): Promise<any> => {
      return fetchPresignedURLAsync(fileName).toPromise();
    };

    const uploadFileToAWSAsync = (
      signedURL: string,
      fileBlob: any
    ): Observable<any> => {
      const headers: any = { 'Content-Type': 'application/pdf' };
      const options: any = { headers: headers };

      return this.httpClient.put(signedURL, fileBlob, options);
    };

    const uploadFileToAWSSync = (
      signedURL: string,
      fileBlob: any
    ): Promise<any> => {
      return uploadFileToAWSAsync(signedURL, fileBlob).toPromise();
    };

    const submitQuoteToBackEndAsync = (customerQuote: any): Observable<any> => {
      const headers: any = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const options: any = { headers: headers };
      this.draftQuoteService.deleteDraftQuation();
      return this.httpClient.post(
        this._configService_.submitQuoteURL,
        customerQuote,
        options
      );
    };

    const submitQuoteToBackEndSync = (customerQuote: any): Promise<any> => {
      return submitQuoteToBackEndAsync(customerQuote).toPromise();
    };

    const leaseDetails: any = customerQuote['lease-details'];
    const uploadedSDS: Array<any> = leaseDetails.sds;

    if (uploadedSDS.length > 0) {
      for (let index = 0; index < uploadedSDS.length; index++) {
        const SDSFile: any = uploadedSDS[index];
        const presignedData: any = await fetchPresignedURLSync(
          SDSFile.sds_name
        );
        const presignedURL: string = presignedData.url;
        const uploadedFile: File = <File>(
          this._holdFileService_.getFileWithName(SDSFile.sds_name)
        );

        await uploadFileToAWSSync(presignedURL, uploadedFile);

        SDSFile.sds_url = presignedData.location;
      }
    }

    return submitQuoteToBackEndAsync(customerQuote);
  }

  hidePhonePlaceholder() {
    this.isPhonePlaceholderHidden = true;
  }

  showPhonePlaceholder() {
    if (this.frmContact.value.phone_no === '')
      this.isPhonePlaceholderHidden = false;
  }

  getString(item: any, fieldName = '') {
    if (Array.isArray(item)) {
      const rslt = [];
      for (let i = 0; i < item.length; i++) {
        if (fieldName === 'preferred-lease-term' && item[i].name === 'Other') {
          rslt.push(this.final['lease-details']['preferred-lease-term-other']);
          continue;
        }

        rslt.push(item[i].name);
      }
      return rslt.join(', ');
    }

    if (typeof item === 'object') {
      return item.name;
    }

    if (fieldName === 'preferred-rail-carrier' && item === 'Other') {
      return this.final['lease-details']['preferred-rail-carrier-other'];
    }
    return item;
  }
}
